// Enumerations
import { AppInformationNeedEnumeration } from 'enumerations/app-information-need.enumeration';
// Types
import { AppInformationContextType } from 'contexts/types/app-information.context.type';

const allNeedDataIsLoaded = (
  informationFlags: AppInformationContextType['informationFlags']
): boolean =>
  Boolean(
    Object.values(AppInformationNeedEnumeration).every((flag: AppInformationNeedEnumeration) =>
      informationFlags.includes(flag)
    )
  );

export { allNeedDataIsLoaded };
